import React from 'react';
export function SecurityBadges() {
  return <div className="w-full flex items-center justify-center py-6" data-id="element-67">
      <NortonLogo data-id="element-68" />
    </div>;
}
function NortonLogo() {
  return <div className="flex flex-col items-center gap-1" data-id="element-69">
      <div className="flex items-center gap-2" data-id="element-70">
        <svg width="36" height="36" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden data-id="element-71">
          <circle cx="20" cy="20" r="17" fill="none" stroke="#FFC20E" strokeWidth="4" data-id="element-72" />
          <path d="M12 21 L17.5 26.5 L29 14" fill="none" stroke="#1f1f1f" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-73" />
        </svg>

        <div className="leading-none" data-id="element-74">
          <div className="flex items-start" data-id="element-75">
            <span className="text-[22px] md:text-[24px] font-bold text-gray-900 tracking-tight" style={{
            fontFamily: 'Arial, sans-serif'
          }} data-id="element-76">
              Norton
            </span>
            <span className="text-[8px] font-bold text-gray-900 mt-0.5 ml-0.5" data-id="element-77">
              TM
            </span>
          </div>
          <div className="text-[12px] md:text-[13px] font-bold text-gray-700 tracking-[0.15em] mt-0.5" style={{
          fontFamily: 'Arial, sans-serif'
        }} data-id="element-78">
            SECURED
          </div>
        </div>
      </div>
      <div className="text-[10px] md:text-[11px] text-gray-700 mt-1" style={{
      fontFamily: 'Arial, sans-serif'
    }} data-id="element-79">
        powered by <span className="font-bold text-gray-900" data-id="element-80">Symantec.</span>
      </div>
    </div>;
}